module.exports = __webpack_public_path__ + "c5f8c05be48584938d7e96e2811f7db2.svg";